import "./EnrolledInvestors.scss";
import { useSelector } from "react-redux";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Select,
  MenuItem,
} from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { IoDocumentTextSharp } from "react-icons/io5";
import { GridLoader, ScaleLoader } from "react-spinners";
import newRequest from "../../utils/newRequest.js";
import CircularButton, { CustomLoadingButton } from "../ui/CustomButton.jsx";
import ConfirmDialog from "../confirmDialog/confirmDialog.jsx";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../ui/CustomSelect.jsx";
import { useTranslation } from "react-i18next";
import { FiSearch } from "react-icons/fi";
import { MdClose, MdEmail, MdGroupWork, MdOutlineNumbers, MdOutlineSmokeFree, MdPhone, MdRefresh } from "react-icons/md";
import OnScreenReports from "../onScreenReports/OnScreenReports.jsx";
import { CiImageOn } from "react-icons/ci";
import AsyncSelect from "react-select/async";
import { useNavigate } from "react-router-dom";
import { TbCertificate } from "react-icons/tb";
import { BsPersonFill, BsSuitcaseLgFill } from "react-icons/bs";
import { GrStatusCriticalSmall } from "react-icons/gr";
import { IoMdPersonAdd } from "react-icons/io";
import { fetchClientsBySearch } from "../../utils/genericFunctions.js";
import { showToast } from "../../toastService.js";
import ValidationMessages from "../validationMessages/ValidationMessages.jsx";

const EnrolledInvestors = ({ fundDocid }) => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [investors, setInvestors] = useState([]);
  const [selectedInvestor, setSelectedInvestor] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(7);
  const [searchTermInvestor, setSearchTermInvestor] = useState("");
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [isEnrollDialogOpen, setIsEnrollDialogOpen] = useState(false);
  const [selectedEnrollInvestor, setSelectedEnrollInvestor] = useState(null);
  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});


  const fetchInvestors = async () => {
    try {
      const res = await newRequest.post("/fund/getEnrolled/", { fund_docid: fundDocid, result_limit: 20, search_term: "" });
      setInvestors(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [currentInvestorPage, setCurrentInvestorPage] = useState(0);
  const handleInvestorsPageChange = (event, newPage) => {
    setCurrentInvestorPage(newPage);
  };

  const filteredInvestors = investors?.filter(
    (row) =>
      row?.investor_xx?.ent_code?.toLowerCase().includes(searchTermInvestor.toLowerCase()) ||
      row?.investor_xx?.ent_name?.toLowerCase().includes(searchTermInvestor.toLowerCase()) ||
      row?.investor_xx?.ent_email?.toLowerCase().includes(searchTermInvestor.toLowerCase()) ||
      row?.investor_xx?.ent_phone_no?.toLowerCase().includes(searchTermInvestor.toLowerCase())
  );

  const paginatedInvestors = filteredInvestors?.slice(
    currentInvestorPage * rowsPerPage,
    currentInvestorPage * rowsPerPage + rowsPerPage
  );

  const handleInvestorsRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 7));
    setCurrentInvestorPage(0);
  };


  useEffect(() => {
    if (fundDocid) {
      fetchInvestors();
    }
  }, [fundDocid]);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteNumGen") {

      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };


  const handleEnrollment = async () => {
    try {
      if (!selectedEnrollInvestor) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select invetor add!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      setIsProcessing(true);
      const res = await newRequest.post("/fund/enrollInvestor",
        {
          fund_docid: fundDocid,
          investor_docid: selectedEnrollInvestor?.ent_docid,
          investor_code: selectedEnrollInvestor?.ent_code,
        },
        { timeout: 10000 }); //timeout set to 10 seconds

      if (res.data?.msg === "added") {
        setIsProcessing(false);
        setInvestors((prevData) => [...prevData, res.data?.doc]);
        setSelectedEnrollInvestor(null);
        setIsEnrollDialogOpen(false);
        showToast(`${selectedEnrollInvestor?.ent_name} successfully enrolled to this fund`, "success");
      } else if (res.data?.msg === "exists") {
        setIsProcessing(false);
        showToast(`${selectedEnrollInvestor?.ent_name} is already enrolled to this fund`, "warning");
      } else if (res.data?.msg === "error") {
        setIsProcessing(false);
        setValidationMessagesResult(res.data?.resultObject);
        setValidationMsgDialog(true);
      } else {
        setIsProcessing(false);
        showToast("Error adding investor!", "error");
      }
    } catch (err) {
      setIsProcessing(false);
      console.log(err);
    }
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  const handleSearchInvestor = async () => {
    try {
      setIsLoading(true);
      if (searchTermInvestor) {
        const res = await newRequest.post("/fund/searchEnrollment/", { fund_docid: fundDocid, result_limit: 20, search_term: searchTermInvestor });
        setInvestors(res.data);
      } else {
        fetchInvestors();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="enrolled-investors">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="enrolled-investors-main-wrapper">
          <div className="enrolled-navbar">
            <div className="enrolled-navbar-left">
              <div className="search-input-wrapper" style={{ display: "flex", width: "100%", height: "36px" }}>
                <FiSearch className="search-input-icon" />
                <input
                  className="search-input"
                  type="text"
                  style={{ height: "30px" }}
                  placeholder={`${t('search')} ${t('investor')}`}
                  value={searchTermInvestor}
                  onChange={(e) => setSearchTermInvestor(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchInvestor();
                  }}
                />
                {searchTermInvestor.length > 0 && (
                  <MdClose
                    onClick={async (e) => {
                      try {
                        await fetchInvestors();
                        setSearchTermInvestor("");
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
                {searchTermInvestor?.length === 0 && (
                  <span className="search-input-icon" />
                )}
              </div>
            </div>
            <div className="enrolled-navbar-right">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                height={"36px"}
                borderRadiusType="left"
                endIcon={<IoDocumentTextSharp />}
                onClick={() => setReportsDialogOpen(true)}>
                {t('reports')}
              </CustomLoadingButton>
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                height={"36px"}
                borderRadiusType="right"
                endIcon={<IoMdPersonAdd />}
                onClick={() => setIsEnrollDialogOpen(true)}>
                {t('enrollInvestor')}
              </CustomLoadingButton>
            </div>
          </div>
          <div className="table-content">
            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
              <Table sx={{ width: "max-content", border: 'none' }}>
                <TableBody className="tablebody">
                  {paginatedInvestors?.map((row, index) => (
                    <TableRow
                      key={row._id}
                      className={`${selectedInvestor?._id === row._id ? "tablerow current" : "tablerow"}`}
                      onClick={() => {
                        try {
                          setSelectedInvestor(row);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      <TableCell className="table-cell center" style={{ maxWidth: "30px" }}>
                        {currentInvestorPage * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell className="table-cell left" style={{ width: "auto" }}>
                        <motion.div
                          className="investor-details-container"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="investor-details-wrapper">
                            <div className="investor-details-left">
                              {row?.investor_xx?.ent_photo_url ?
                                <img src={row?.investor_xx?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "40px", height: "40px" }} />}
                            </div>
                            <div className="investor-details-right">
                              <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                                <span className="sub-title">{row?.investor_xx?.ent_name}</span>
                                {row?.time_ago_xx && <span className="enrolled-time-ago" style={{ fontSize: "10px" }}>{`${t('enrolled')} ${row?.time_ago_xx}`}</span>}
                              </div>
                              <div className="email-phone-row">
                                <span className="email-phone-details" style={{ flex: "1.5" }}>
                                  <MdEmail className="icon" /> <span className="sub-title">{row?.investor_xx?.ent_email || ""}</span>
                                </span>
                                <span className="email-phone-details" style={{ flex: "1" }}>
                                  <MdPhone className="icon" /> <span className="sub-title">{row?.investor_xx?.ent_phone_no || ""}</span>
                                </span>
                                <span className="email-phone-details" style={{ flex: "1" }} >
                                  <MdOutlineNumbers className="icon" /> <span className="sub-title">{row?.investor_xx?.ent_code}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {investors?.length > rowsPerPage &&
                <TablePagination
                  rowsPerPageOptions={[7]}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleInvestorsRowsPerPage}
                  component="div"
                  count={investors?.length}
                  rows={investors}
                  page={currentInvestorPage}
                  onPageChange={handleInvestorsPageChange}
                />}
            </TableContainer>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={handleCloseNotifyDialog}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('reports')}</span>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["fund-reports"]}
                documentData={{
                  docNo: "",
                  docType: "AM Fund",
                  docId: "1",
                }} />
            </div>
          </div>
        </motion.div>)}

      {/* end of adding organization unit */}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {isEnrollDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('enrollment')}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setSelectedEnrollInvestor(null);
                    setIsEnrollDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <AsyncSelect
                  id="investor_code"
                  name="investor_code"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="400px"
                  value={selectedEnrollInvestor}
                  onChange={(selectedOption) => {
                    try {
                      setSelectedEnrollInvestor(selectedOption);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                  isSearchable={true}
                  placeholder={t('investor')}
                  noOptionsMessage={() => "Type Minimum 3 Letter to Search"} />
              </div>
              <div className="selected-investor-wrapper">
                <hr className="separator-h" />
                <div className="investor">
                  <div className="investor-left">
                    {selectedEnrollInvestor?.ent_photo_url ?
                      <img src={selectedEnrollInvestor?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "70px", height: "70px" }} />}
                  </div>
                  <div className="investor-right">
                    <span className="main-title"> {selectedEnrollInvestor?.ent_name} </span>
                    <span className="investor-row-icon" style={{ flex: "1.5" }}>
                      <MdEmail className="icon" /> <span className="sub-title">{selectedEnrollInvestor?.ent_email || selectedEnrollInvestor ? t('unspecified') : ""}</span>
                    </span>
                    <span className="investor-row-icon" style={{ flex: "1" }}>
                      <MdPhone className="icon" /> <span className="sub-title">{selectedEnrollInvestor?.ent_phone_no || selectedEnrollInvestor ? t('unspecified') : ""}</span>
                    </span>
                    <span className="investor-row-icon" style={{ flex: "1" }} >
                      <MdOutlineNumbers className="icon" /> <span className="sub-title">{selectedEnrollInvestor?.ent_code}</span>
                    </span>
                    {selectedEnrollInvestor?.ent_type === "Individual" &&
                      <span className="investor-row-icon" style={{ flex: "1" }} >
                        <BsPersonFill className="icon" /> <span className="sub-title">{`${t('gender')} : ${selectedEnrollInvestor?.ent_gender} | ${selectedEnrollInvestor?.ent_age_xx}`}</span>
                      </span>}
                  </div>
                </div>
                <hr className="separator-h" />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton onClick={handleEnrollment}>{t('enroll').toUpperCase()}</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('messages')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setValidationMsgDialog(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <ValidationMessages messageData={validationMessagesResult} />
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
};


export default EnrolledInvestors;
